import { useEffect } from "react";

const SITE = "https://thezebo.com";

function setTag(selector, attr, key, value, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attr === "name" ? "meta" : attr === "property" ? "meta" : "link");
    if (attr === "rel") el.setAttribute("rel", key);
    else el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  if (attr === "rel") el.setAttribute("href", content);
  else el.setAttribute("content", content);
}

/**
 * Per-page SEO. Updates <title>, meta description, OG/Twitter and canonical.
 * Crawler-friendly for CSR (Googlebot renders JS).
 */
export default function Seo({ title, description, path = "/", image }) {
  useEffect(() => {
    const fullTitle = title || "ZEBO India Pvt Ltd — Interior Design, Modular Kitchens & Wardrobes in Kolkata";
    const desc =
      description ||
      "ZEBO India Private Limited — full-home interiors, modular kitchens and wardrobes in Kolkata. Book a free design consultation.";
    const url = `${SITE}${path}`;
    const img = image || `${SITE}/logo.png`;

    document.title = fullTitle;
    setTag('meta[name="description"]', "name", "description", null, desc);
    setTag('meta[property="og:title"]', "property", "og:title", null, fullTitle);
    setTag('meta[property="og:description"]', "property", "og:description", null, desc);
    setTag('meta[property="og:url"]', "property", "og:url", null, url);
    setTag('meta[property="og:image"]', "property", "og:image", null, img);
    setTag('meta[name="twitter:title"]', "name", "twitter:title", null, fullTitle);
    setTag('meta[name="twitter:description"]', "name", "twitter:description", null, desc);
    setTag('meta[name="twitter:image"]', "name", "twitter:image", null, img);
    setTag('link[rel="canonical"]', "rel", "canonical", null, url);
  }, [title, description, path, image]);

  return null;
}
